import {
   DisplayableMessage,
   PatientCannotBeRemovedFault,
   PatientRemoveCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { patientTranslationKeys } from '../../translations';

import { PatientRemoveFormBean } from './PatientRemoveForm.types';

type PatientRemoveActionRenderProps = {
   removePatient: (parameters: PatientRemoveFormBean) => Promise<void>;
};

type PatientRemoveActionProps = {
   children: (renderProps: PatientRemoveActionRenderProps) => JSX.Element;
   onSuccess: VoidFunction;
   onPatientCannotBeRemovedFault: (displayableMessage: DisplayableMessage) => void;
   patientId: number;
};

export const PatientRemoveAction = (props: PatientRemoveActionProps): JSX.Element => {
   const { executeAsync: removePatient } = useCqrsCommand<void, PatientRemoveFormBean, PatientCannotBeRemovedFault>(
      (parameters) => {
         const command = new PatientRemoveCommand();
         command.patientId = props.patientId;
         command.patientRemovalReasonId = parameters.removalReason!.id;
         command.description = Choice.withUseDefaultIfNull(parameters.description);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(patientTranslationKeys.patientDataRemoved);
            props.onSuccess();
         },
         onFault: {
            'egabinet-patient-frontend-api:PatientCannotBeRemovedFault': ({ displayableMessage }) => {
               return props.onPatientCannotBeRemovedFault(displayableMessage);
            },
         },
      }
   );

   return props.children({
      removePatient: removePatient,
   });
};
